/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListTemplateRequest } from '../models/api-response-list-template-request';
import { ApiResponsePagedResultTemplateRequest } from '../models/api-response-paged-result-template-request';
import { ApiResponsePagedResultTemplateRequestChatSearchResult } from '../models/api-response-paged-result-template-request-chat-search-result';
import { ApiResponseTemplateRequest } from '../models/api-response-template-request';
import { createTemplateRequest } from '../fn/template-request-api/create-template-request';
import { CreateTemplateRequest$Params } from '../fn/template-request-api/create-template-request';
import { deleteTemplateRequest } from '../fn/template-request-api/delete-template-request';
import { DeleteTemplateRequest$Params } from '../fn/template-request-api/delete-template-request';
import { getTemplateRequestByReference } from '../fn/template-request-api/get-template-request-by-reference';
import { GetTemplateRequestByReference$Params } from '../fn/template-request-api/get-template-request-by-reference';
import { listTemplateRequests } from '../fn/template-request-api/list-template-requests';
import { ListTemplateRequests$Params } from '../fn/template-request-api/list-template-requests';
import { searchTemplateRequests } from '../fn/template-request-api/search-template-requests';
import { SearchTemplateRequests$Params } from '../fn/template-request-api/search-template-requests';
import { searchTemplateRequestsWithChats } from '../fn/template-request-api/search-template-requests-with-chats';
import { SearchTemplateRequestsWithChats$Params } from '../fn/template-request-api/search-template-requests-with-chats';
import { updateTemplateRequest } from '../fn/template-request-api/update-template-request';
import { UpdateTemplateRequest$Params } from '../fn/template-request-api/update-template-request';

@Injectable({ providedIn: 'root' })
export class TemplateRequestApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateTemplateRequest()` */
  static readonly UpdateTemplateRequestPath = '/v1/api/ui/template-request/media/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTemplateRequest()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateTemplateRequest$Response(params: UpdateTemplateRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTemplateRequest>> {
    return updateTemplateRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTemplateRequest$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateTemplateRequest(params: UpdateTemplateRequest$Params, context?: HttpContext): Observable<ApiResponseTemplateRequest> {
    return this.updateTemplateRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTemplateRequest>): ApiResponseTemplateRequest => r.body)
    );
  }

  /** Path part for operation `searchTemplateRequests()` */
  static readonly SearchTemplateRequestsPath = '/v1/api/ui/template-request/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTemplateRequests()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTemplateRequests$Response(params: SearchTemplateRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultTemplateRequest>> {
    return searchTemplateRequests(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTemplateRequests$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTemplateRequests(params: SearchTemplateRequests$Params, context?: HttpContext): Observable<ApiResponsePagedResultTemplateRequest> {
    return this.searchTemplateRequests$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultTemplateRequest>): ApiResponsePagedResultTemplateRequest => r.body)
    );
  }

  /** Path part for operation `searchTemplateRequestsWithChats()` */
  static readonly SearchTemplateRequestsWithChatsPath = '/v1/api/ui/template-request/search-with-chats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTemplateRequestsWithChats()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTemplateRequestsWithChats$Response(params: SearchTemplateRequestsWithChats$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultTemplateRequestChatSearchResult>> {
    return searchTemplateRequestsWithChats(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTemplateRequestsWithChats$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTemplateRequestsWithChats(params: SearchTemplateRequestsWithChats$Params, context?: HttpContext): Observable<ApiResponsePagedResultTemplateRequestChatSearchResult> {
    return this.searchTemplateRequestsWithChats$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultTemplateRequestChatSearchResult>): ApiResponsePagedResultTemplateRequestChatSearchResult => r.body)
    );
  }

  /** Path part for operation `createTemplateRequest()` */
  static readonly CreateTemplateRequestPath = '/v1/api/ui/template-request/media';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTemplateRequest()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createTemplateRequest$Response(params: CreateTemplateRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTemplateRequest>> {
    return createTemplateRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTemplateRequest$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createTemplateRequest(params: CreateTemplateRequest$Params, context?: HttpContext): Observable<ApiResponseTemplateRequest> {
    return this.createTemplateRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTemplateRequest>): ApiResponseTemplateRequest => r.body)
    );
  }

  /** Path part for operation `listTemplateRequests()` */
  static readonly ListTemplateRequestsPath = '/v1/api/ui/template-request/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listTemplateRequests()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTemplateRequests$Response(params: ListTemplateRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListTemplateRequest>> {
    return listTemplateRequests(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listTemplateRequests$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTemplateRequests(params: ListTemplateRequests$Params, context?: HttpContext): Observable<ApiResponseListTemplateRequest> {
    return this.listTemplateRequests$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListTemplateRequest>): ApiResponseListTemplateRequest => r.body)
    );
  }

  /** Path part for operation `getTemplateRequestByReference()` */
  static readonly GetTemplateRequestByReferencePath = '/v1/api/ui/template-request/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTemplateRequestByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTemplateRequestByReference$Response(params: GetTemplateRequestByReference$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTemplateRequest>> {
    return getTemplateRequestByReference(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTemplateRequestByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTemplateRequestByReference(params: GetTemplateRequestByReference$Params, context?: HttpContext): Observable<ApiResponseTemplateRequest> {
    return this.getTemplateRequestByReference$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTemplateRequest>): ApiResponseTemplateRequest => r.body)
    );
  }

  /** Path part for operation `deleteTemplateRequest()` */
  static readonly DeleteTemplateRequestPath = '/v1/api/ui/template-request/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTemplateRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTemplateRequest$Response(params: DeleteTemplateRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTemplateRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTemplateRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTemplateRequest(params: DeleteTemplateRequest$Params, context?: HttpContext): Observable<void> {
    return this.deleteTemplateRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
